// extracted by mini-css-extract-plugin
module.exports = {"advertisingBenefits":"advertisingBenefits___3WTqu","title":"title___3QAgA"};